<div class="tab-pane" role="tabpanel" id="subdivision">
    <fieldset id="agregar_subdivision" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <div class="form-horizontal">
                        <form [formGroup]="form">
                            <h3 class="form-signin-heading"><strong>Subdivisi&oacute;n</strong></h3>
                            <hr />
                            <div class="col-md-12">
                                <label for="sup_ant_loteo" class="col-md-3" align="left" style="padding-top: 20px;">Situación anterior:</label>
                            </div>
                            <div class="form-group">
                                <div class="col-md-1"></div>
                                <label for="sup_ant_loteo" class="col-md-2" align="left" style="padding-top: 20px;">Lote existente</label>
                                <div class="col-md-3">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Superficie (m2)" id="sup_ant_loteo" name="sup_ant_loteo" formControlName="sup_ant_loteo">
                                        <span matSuffix>m²</span>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <label for="clasificacion" class="col-md-3" align="left" style="padding-top: 20px;">Situación actual (Predios a enajenar):</label>
                            </div>
                            <div class="form-group">
                                <div class="col-md-1"></div>
                                <label for="num_anteproy_act" class="col-md-2" align="left" style="padding-top: 20px;">Lotes resultantes</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Nº" id="num_anteproy_act" name="num_anteproy_act" formControlName="num_anteproy_act" >
                                    </mat-form-field>
                                </div>
                                <label for="sup_anteproy_act" class="col-md-2" align="left" style="padding-top: 20px;">Superficie</label>
                                <div class="col-md-3">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="m2" id="sup_anteproy_act" name="sup_anteproy_act" formControlName="sup_anteproy_act" >
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="form-group" style="padding-top: 20px">
                                <div class="col-md-1"></div>
                                <label for="hoja_anexa_loteo" class="col-md-2" align="left" >Se adjunta hoja anexa (en caso de que sean mas lotes)</label>
                                <div>
                                    <mat-radio-group formControlName="hoja_anexa_loteo">
                                        <mat-radio-button style="padding-right: 20px" name="hoja_anexa_loteo" value="SI">Si</mat-radio-button>
                                        <mat-radio-button style="padding-right: 20px" name="hoja_anexa_loteo" value="NO">NO</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>
                            <div class="col-md-12" style="padding-top: 30px ; padding-bottom: 10px" align="center">
                                <button mat-raised-button color="primary" style="padding-top: 5px" id="ingreso_lotes" (click)="add_caract_division()">
                                        Agregar Subdivisiones
                                    <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                </button>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
            <div class="datatable_lotes">
                <ngx-datatable class="material expandable" [messages]="''" [rows]="rows" [columnMode]="'force'" [headerHeight]="'auto'" [footerHeight]="'auto'" [rowHeight]="'auto'">
                    <ngx-datatable-column>
                        <ng-template ngx-datatable-header-template>
                            <span>LOTES RESULTANTES</span>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{row.num_anteproy_act}}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column>
                        <ng-template ngx-datatable-header-template>
                            <span>SU</span>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{row.sup_anteproy_act}}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column>
                        <ng-template ngx-datatable-header-template>
                            <span>OPCIONES</span>
                        </ng-template>
                        <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                            <span (click)="get_caract_division(rowIndex)" style="padding-right: 5px;"><i class="glyphicon glyphicon-pencil"></i></span>
                            <span (click)="delete_caract_division(rowIndex)"><i class="glyphicon glyphicon-trash"></i></span>
                        </ng-template>
                    </ngx-datatable-column>

                </ngx-datatable>


            </div>
        </div>
    </fieldset>

    <ng-template #openModal>
        <h2 mat-dialog-title>Informaci&oacute;n de las subdivisiones</h2>
        <mat-dialog-content>
            <div class="form-horizontal">
                <div class="form-group">
                    <label class="col-md-4 control-label" for="num_anteproy_act">Lotes resultantes</label>
                    <div class="col-md-6">
                        <input id="id" name="id" type="hidden" placeholder="id" class="form-control input-md" [(ngModel)]="temp_carct_loteo.id">
                        <input id="num_anteproy_act" name="num_anteproy_act" type="text" placeholder="num_anteproy_act" class="form-control input-md" [(ngModel)]="temp_carct_loteo.num_anteproy_act">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="sup_anteproy_act">Superficie</label>
                    <div class="col-md-6">
                        <input id="sup_anteproy_act" name="sup_anteproy_act" type="text" placeholder="sup_anteproy_act" class="form-control input-md" [(ngModel)]="temp_carct_loteo.sup_anteproy_act">
                    </div>
                    <div class="col-md-2"></div>
                </div>

            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_loteo" data-dismiss="modal" (click)="cleanData()">Cancelar</button>
            <button mat-raised-button color="primary" id="ingreso_loteo" (click)="savecaract_division()">Ingresar Loteo <i class="fa fa-user-o " aria-hidden="true "></i></button>
        </mat-dialog-actions>
    </ng-template>
    <!--End Material Dialog-->
</div>
<div class="separator"></div>